import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCompositionAPI from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueToast from 'vue-toast-notification';
import i18nFactory from '@/helpers/i18n/i18nFactory';
import mixpanel from 'mixpanel-browser';
import * as Sentry from '@sentry/vue';
import './assets/icons/font-awesome-icons';
import './assets/tailwind.css';
import '../node_modules/@zidsa/ui/styles/global.css';
import 'vue-toast-notification/dist/theme-sugar.css';

const i18n = i18nFactory();

if (process.env.NODE_ENV !== 'local') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracePropagationTargets: ['partner.zid.sa'],
    ignoreErrors: [/^(?:https?:\/\/)?(?:[^.]+\.)?clarity\.ms(\/.*)?/],
  });
}

mixpanel.init(process.env.VUE_APP_MIXPANEL_KEY, {
  record_sessions_percent: 1,
  record_idle_timeout_ms: 60000,
  record_mask_text_class: '',
  record_mask_text_selector: '',
  record_max_ms: 900000,
});

Vue.use(VueToast, {
  position: 'top-right',
  pauseOnHover: true,
  dismissible: true,
  duration: 5000,
});
Vue.component('multiselect', window.VueMultiselect.default);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(VueCompositionAPI);

new Vue({ router, store, i18n, render: (h) => h(App) }).$mount('#app');
